import { Box, Button, Grow, Modal, Slide, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useGlobalContext } from "../../../../context/GlobalContext";
import "./logoutandDelete.css";

const LogoutandDeleteModal = ({
  openModal,
  handleClose,
  deleteItem,
  modalType,
  onAction,
  data,
}) => {
  const navigate = useNavigate();
  const {
    setClientForm,
    setSearch,
    setInfoFilter,
    setHomeScreen,
    setCartScreen,
    resetCart,
  } = useGlobalContext();

  const handleClearFilter = () => {
    setSearch("");
    setInfoFilter("");
  };

  const handleClearCart = () => {
    // Cleared before the client is forgotten: resetCart needs to know which
    // client's saved cart to drop on the server.
    resetCart("CLEAR");
    localStorage.removeItem("ClientData");
    localStorage.removeItem("DynamicClient")
    localStorage.removeItem("clientOrderData");
    setHomeScreen(false);
    setCartScreen(false);
    setClientForm(false);
    navigate("/home");
  };

  const getModalContent = () => {
    switch (modalType) {
      case "logout":
        return {
          heading: "Are you sure you want to log out?",
          buttons: [
            {
              text: "Log out",
              color: "#E77B7B",
              action: () => {
                navigate("/login");
                localStorage.removeItem("token");
                localStorage.removeItem("role");
                localStorage.removeItem("isAdmin");
                localStorage.removeItem("ClientData");
                localStorage.removeItem("DynamicClient")
                localStorage.removeItem("clientOrderData");
                // Logging out is a route change, not a page load, so the
                // in-memory cart has to be emptied too - otherwise the next
                // login still shows the previous client's designs. "LOCAL"
                // leaves the saved cart alone, so logging in elsewhere - or
                // back in here - picks it up again.
                resetCart("LOCAL");
                setClientForm(false);
              },
            },
            {
              text: "Keep",
              color: "#50C878",
              action: handleClose,
            },
          ],
        };
      case "delete":
        return {
          heading: (
            <>
              Are you sure you want to delete{" "}
              <strong>{deleteItem?.styleNumber || "this item"}</strong>?
            </>
          ),
          buttons: [
            {
              text: "No",
              color: "#E77B7B",
              action: handleClose,
            },
            {
              text: "Yes",
              color: "#50C878",
              action: () => {
                onAction(deleteItem);
                handleClose();
              },
            },
          ],
        };
      case "clearCart":
        return {
          heading: "Are you sure you want to clear Cart ?",
          buttons: [
            {
              text: "Yes",
              color: "#E77B7B",
              action: () => {
                handleClearCart();
                handleClose();
              },
            },
            {
              text: "No",
              color: "#50C878",

              action: handleClose,
            },
          ],
        };
      case "Place Order":
        return {
          heading: "Are you sure you want to Place Order?",
          buttons: [
            {
              text: "Discard",
              color: "#E77B7B",
              action: handleClose,
            },
            {
              text: "Place",
              color: "#50C878",
              action: onAction,
            },
          ],
        };
      case "clearFilter":
        return {
          heading: "Are you sure you want to Clear Filter?",
          buttons: [
            {
              text: "Keep",
              color: "#E77B7B",
              action: handleClose,
            },
            {
              text: "Clear",
              color: "#50C878",
              action: () => {
                handleClearFilter();
                handleClose();
              },
            },
          ],
        };
      case "managerRequestConfirmation":
        return {
          heading: (
            <>
              Are you sure you want to receive{" "}
              <strong style={{ textTransform: "capitalize" }}>
                {data?.trayName}
              </strong>{" "}
              from{" "}
              <strong style={{ textTransform: "capitalize" }}>
                {data?.salesPersonName}
              </strong>{" "}
              ?
            </>
          ),
          buttons: [
            {
              text: "No",
              color: "#E77B7B",
              action: handleClose,
            },
            {
              text: "Yes",
              color: "#50C878",
              action: () => {
                onAction();
                handleClose();
              },
            },
          ],
        };
      case "sync":
        return {
          heading: (
            <>
              Sync{" "}
              <strong style={{ textTransform: "capitalize" }}>
                {data?.clientName}
              </strong>{" "}
              order with Gati ?
            </>
          ),
          buttons: [
            {
              text: "No",
              color: "#E77B7B",
              action: handleClose,
            },
            {
              text: "Yes",
              color: "#50C878",
              action: () => {
                
                onAction(data);
                handleClose();
              },
            },
          ],
        };
      default:
        return {
          heading: "Are you sure?",
          buttons: [
            {
              text: "Cancel",
              color: "#E77B7B",
              action: handleClose,
            },
            {
              text: "Confirm",
              color: "#50C878",
              action: () => {
                onAction?.();
                handleClose();
              },
            },
          ],
        };
    }
  };

  const { heading, buttons } = getModalContent();

  let content = (
    <Box
      className="modal-body-logout"
      sx={{
        top: modalType != "Place Order" && "40% !important",
        bottom: modalType === "Place Order" && "1.8vw",
        height: modalType === "Place Order" ? "8vw" : "auto",
        width: modalType === "Place Order" && "22vw",
        minWidth: modalType != "Place Order" && "25vw",
      }}
    >
      <Box
        sx={{
          height: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-evenly",
          gap: modalType === "Place Order" && "0.7vw",
        }}
      >
        <Typography className="modal-heading">{heading}</Typography>
        <Box
          className="btn-modal"
          sx={{
            gap: modalType === "Place Order" ? "1.8vw" : "0.5vw",
          }}
        >
          {buttons.map((button, index) => (
            <Button
              key={index}
              className="btn"
              sx={{
                backgroundColor: button.color,
                width: modalType === "Place Order" && "4vw",
                minWidth: modalType === "Place Order" ? "8vw" : "11vw",
                whiteSpace: "nowrap",
              }}
              onClick={button.action}
            >
              {button.text}
            </Button>
          ))}
        </Box>
      </Box>
    </Box>
  );

  return (
    <Modal
      open={openModal}
      onClose={handleClose}
      sx={{
        display: "flex",
        justifyContent: modalType === "Place Order" ? "end" : "center",
        marginRight: modalType === "Place Order" ? "2vw" : 0,
      }}
      slotProps={{
        backdrop: {
          sx: {
            backgroundColor: modalType === "Place Order" && "transparent",
          },
        },
      }}
    >
      {modalType === "Place Order" ? (
        <Slide direction="left" in={openModal}>
          {content}
        </Slide>
      ) : (
        <Grow in={openModal}>{content}</Grow>
      )}
    </Modal>
  );
};

export default LogoutandDeleteModal;

